export const state = () => {
	return {
		targetings: [],
		ttl: null,
		cache_duration: 1800000, // 30 minutes
		cache_key: '',
	}
}

function isInCache(state, companyId) {
	if (state.cache_key !== buildCacheKey(companyId)) {
		return false
	}
	if (state.ttl === null || state.ttl < Date.now()) {
		return false
	}
	return true
}

function buildCacheKey(companyId) {
	return 'company:' + companyId + 'targetings'
}

export const actions = {
	async getTargetings({ state, commit }, { companyId }) {
		if (isInCache(state, companyId)) {
			return state.targetings
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/targetings/`)
			.then((res) => {
				return res.filter((list) => list.company === companyId)
			})
			.then((res) => {
				commit('setTargetings', { data: res, companyId })
				return res
			})
			.catch((err) => {
				commit('clearCache')
				throw err
			})
	},

	async createTargeting({ commit }, { companyId, name, creatorIds }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/targetings/`, {
				method: 'POST',
				body: {
					name,
					target: creatorIds,
					type: 0, // ambassadors
				},
			})
			.then((res) => {
				commit('invalidateCache')
				return res
			})
			.catch((err) => {
				commit('invalidateCache')
				throw err
			})
	},

	async appendToTargeting({ commit }, { companyId, targetingId, creatorIds }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/targetings/${targetingId}/`, {
				method: 'PUT',
				body: { target: creatorIds },
			})
			.then((res) => {
				commit('invalidateCache')
				return res
			})
			.catch((err) => {
				commit('invalidateCache')
				throw err
			})
	},

	async removeFromTargeting({ commit }, { companyId, targetingId, creatorIds }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/targetings/${targetingId}/`, {
				method: 'PUT',
				body: { target: creatorIds },
			})
			.then((res) => {
				commit('invalidateCache')
				return res
			})
			.catch((err) => {
				commit('invalidateCache')
				throw err
			})
	},
}

export const mutations = {
	setTargetings(state, { data, companyId }) {
		state.targetings = data
		state.ttl = Date.now() + state.cache_duration
		state.cache_key = buildCacheKey(companyId)
	},

	clearCache(state) {
		state.ttl = null
		state.cache_key = ''
	},

	invalidateCache(state) {
		state.cache_key = ''
	},
}
